
import React from "react";
import {GatsbyImage} from 'gatsby-plugin-image'
import { graphql } from "gatsby";

import Header from "../components/header";

export default function PostTemplate({data}) {
   

    const {content, title, date} = data.wpPost
  

    return(
        <>
            <Header/>
            <div className="flex justify-center">
            <main className="w-full px-4" style={{maxWidth: '800px', marginTop: '200px', marginBottom: '200px'}}>
                    <h5 className="font-caslon">11/02/2024</h5>
                    <h1 className="text-5xl md:text-6xl">Blog 1</h1>
                    <section 
                    dangerouslySetInnerHTML={{__html: content}}
                     style={{lineHeight: '40px'}}></section>
                </main>
            </div>
        </>
    )
}

export const query = graphql`
  query Post($slug: String) {
    site {
      siteMetadata {
        siteUrl
      }
    }
    wpPost(slug: { eq: $slug }) {
      content
      excerpt
      slug
      title
      date
      featuredImage {
        node {
          gatsbyImage(width: 600)
        }
      }
      seo {
        title
        metaDesc
        canonical
      }
      extraEntriesFields {
        subtitle
        introduction
      }
    }
  }
`;
